document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('private-protected')) return;

  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });

  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });

  function harden() {
    document.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });
  }

  harden();
  new MutationObserver(harden).observe(document.body, {
    childList: true,
    subtree: true
  });
});